module.exports = __WEBPACK_EXTERNAL_MODULE_971__;


//////////////////
// WEBPACK FOOTER
// external "History"
// module id = 971
// module chunks = 1